/**
 * This file exposes the services for tests
 */
import { productService } from './services/products';

// Declare TireFilters on the Window interface
declare global {
  interface Window {
    TireFilters: {
      productService: typeof productService;
    };
  }
}

// Make the services available globally for testing
window.TireFilters = {
  productService
};
